<template>
  <div id="app" :class="vueAppClasses">
    <router-view :key="$route.fullPath" @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import jwt from '@/http/requests/auth/jwt/index.js'
import { db } from './firebase/firebaseConfig'

export default {
  data() {
    return {
      vueAppClasses: [],
    }
  },
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl'(val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    },
  },
  methods: {
    toggleClassInBody(className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },
    // Fetch firestore data and subscription data and store it in vuex store
    async fetchFirestore() {
      await this.fetchSubscriptionDetails(JSON.parse(localStorage.getItem('userInfo')).database)
      await db
        .collection('cloudify')
        .doc(JSON.parse(localStorage.getItem('userInfo')).uid)
        .onSnapshot(async (firestoreData) => {
          this.$store.dispatch('ADD_CLIENT_DATA', firestoreData.data())
          const sheetNames = Object.keys(firestoreData.data().sheets)
          this.$store.dispatch('ADD_SHEET_NAMES', [...sheetNames])
        })
    },
    // This function fetches subscription data and store it in Vuex state
    async fetchSubscriptionDetails(id) {
      const snapshot = await db.collection('customers').doc(id).collection('subscriptions').where('status', 'in', ['trialing', 'active']).get()
      // In this implementation we only expect one active or trialing subscription to exist.
      const doc = snapshot.docs[0]
      if (doc !== undefined) {
        this.$store.dispatch('GET_SUBSCRIPTIONS', JSON.parse(JSON.stringify(doc.data())))
      } else {
        this.$store.dispatch('GET_SUBSCRIPTIONS', 'undefined')
      }
    },
  },
  computed: {},
  async mounted() {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    await this.fetchFirestore()
  },
  async created() {
    // jwt
    jwt.init()

    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>
